<template>
<v-layout>
        <v-snackbar
      class="mt-5"
      v-if="localToast"
      v-model="localToast"
      :color="localToast.color"
      multi-line
      top
      right
      :timeout="localToast.timeout"
      >
        {{localToast.text}}
    </v-snackbar>
  <v-parallax
      dark
      :src="require('../assets/background.svg')"
      height="100%"
      style="padding-top:5%; min-height: 120vh; min-width:100vw;"
    >
  <v-layout justify-center column class="text-xs-center">
      <v-flex xs12 row justify-center>
      <v-flex md6 xs12 justify-center class="text-xs-center">
        <span :class="{'display-2': $vuetify.breakpoint.smAndDown, 'display-4': $vuetify.breakpoint.mdAndUp, 'font-weight-light': true}">
          The Org Chart that remembers
        </span>
        <ChartBox :chart="$vuetify.breakpoint.smAndDown ? fakeOrgOnePerson : fakeOrgOnePerson" id="0" :scale="1" :mappingScale="1" :whichPageToShow=1 :ignoreMargin="true" :style="{'margin-top': '75px', 'margin-bottom': ($vuetify.breakpoint.smAndDown ? '0px' : '100px')}" ref="examplePerson">
        </ChartBox>
      </v-flex>
      <v-flex xs12 md5 justify-center :class="{'ml-0': $vuetify.breakpoint.smAndDown, 'ml-5': $vuetify.breakpoint.mdAndUp}">
        <span :class="{'hidden-md-and-up': true,'display-1': $vuetify.breakpoint.smAndDown, 'display-2': $vuetify.breakpoint.mdAndUp, 'font-weight-light': true, 'mt-12': true, 'mb-12': true}" style="display:block;">
          <b>Org Owl</b> is the only Org Chart software that lets you see what your organization looked like one day, month, or year ago - automatically!
      </span>
        <v-card :style="{'margin-bottom': $vuetify.breakpoint.smAndDown ? '75px' : '150px', 'pa-5': $vuetify.breakpoint.mdAndUp}">
          <v-card-title style="background-color: rgba(249, 191, 59, 1); margin-bottom:20px" class="justify-space-between">
            <span :class="{'subtitle-2': $vuetify.breakpoint.smAndDown, 'headline': $vuetify.breakpoint.mdAndUp}" style="display:block;">
              <b>Coming Soon!</b> Sign up now for access to the exclusive beta!  
            </span>
          </v-card-title>
          <v-flex row justify-space-around style="width:90%;height:100%" ml-3 align-top>
          <v-text-field v-if="!submittedForm" @keyup.enter="submitForm" label="Your Email" hint="We promise to only email you about Org Owl!" persistent-hint type="email" v-model="emailInput" style="max-width: 400px;" solo outlined filled>
          </v-text-field>
          <v-btn large color="rgba(249, 191, 59, 1)" :loading="loading" v-if="!submittedForm" @click="submitForm" dark style="max-height: 100%; color: rgba(249, 191, 59, 1);" height="56" >
            <span style="color: black">Update Me!</span>
          </v-btn>
          <span v-if="submittedForm" style="height:100%; margin:10px"><v-icon color="green">fas fa-check</v-icon> Thanks for your interest! Expect to hear from us soon with more details!</span>
          </v-flex>
        </v-card>
        <span :class="{'hidden-sm-and-down': true,'display-1': $vuetify.breakpoint.smAndDown, 'display-2': $vuetify.breakpoint.mdAndUp, 'font-weight-light': true, 'mt-1': $vuetify.breakpoint.mdAndUp, 'mt-3': $vuetify.breakpoint.smAndDown}" style="display:block;max-height: 360px">
          <b>Org Owl</b> is the only Org Chart software that lets you see what your organization looked like one day, month, or year ago - automatically!
      </span>
      </v-flex>
    </v-flex>
  </v-layout>
  </v-parallax>
  </v-layout>
</template>

<script>
import ChartBox from './ChartBox';
import axios from "axios";
axios.defaults.baseURL = "https://todotrackerapi.azurewebsites.net/";

export default {
  components: {ChartBox},
    mounted() {
      window.addEventListener('resize', this.recursiveDrawLines)
      this.get("api/Account/Heartbeat")
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.recursiveDrawLines)
    },
    methods: {
      submitForm: async function() {
        if (this.emailInput.length > 3 && this.emailInput.indexOf('@') > 0) {
          this.loading = true
          this.post('/api/OrgOwl/ImInterested', {'Email': this.emailInput, 'Comment': ''}).then(() => {
          this.submittedForm = true
          this.localToast = {
            text: `Success! Looking forward to chatting!`,
            color: "success",
            timeout: 5000
          }
          }).catch( () => {
          this.localToast = {
            text: `Error processing your request, please email Support@StudiedSolutions.com`,
            color: "error",
            timeout: 5000
          }
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.localToast = {
            text: `Please enter a valid email!`,
            color: "error",
            timeout: 5000
          }
        }
      },
      recursiveDrawLines: function() {
        this.$refs.examplePerson.drawLines()
      },
      get: function(uri, data = {}) {
        if (Object.keys(data).length > 0) {
          uri = `${uri}`;
        }

        return axios.get(uri, {
          headers: {},
          withCredentials: false
        });
      },
      post: function (uri, data) {
        return axios.post(uri, data, {
          headers: {'Content-Type': 'application/json'},
          withCredentials: false
        })
      }
    },
  data: () => ({
    hide: true,
    localToast: null,
    loading: false,
    emailInput: '',
    submittedForm: false,
    numberOfCharts: 1,
    fakeOrgOnePerson: {
                jobTitle: 'Founder',
                department: 'Executive',
                budgetedHours: '40+',
                salary: '55,000',
                person: {
                    firstName: 'Tom',
                    hireDate: new Date('2001-03-14'),
                    lastName: 'McGee',
                    imageUrl: require('../assets/TomMcGee-Real.jpg')
                },
                reportsHorizontal: true,
                reports: [ ]
              },
    fakeOrgChartTwoPeople: {
                jobTitle: 'Founder',
                department: 'Executive',
                budgetedHours: '40+',
                salary: '55,000',
                person: {
                    firstName: 'Tom',
                    hireDate: new Date('2001-03-14'),
                    lastName: 'McGee',
                    imageUrl: require('../assets/TomMcGee-Real.jpg')
                },
                reportsHorizontal: true,
                reports: [ 
                    {
                        jobTitle: 'CTO',
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '40,000',
                        person: {
                            firstName: 'Megan',
                            lastName: 'Runn',
                            hireDate: new Date('2001-05-12'),
                            imageUrl: require('../assets/MeganRunn.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    }
                ]
    }
  }),
};
</script>

<style lang="scss" scoped>
.org-chart-user {
  min-width: 200px;
  width: 200px;
  min-height: 100px;
  height:100px;
  z-index: 2;
}

</style>

